export interface MpcChest {
  chestId: number;
  chestText: string;
  chestType: string;
  isAvailable: boolean;
  isExpired?: boolean;
  skinType: string;
  tierId: number;
  assets: ChestAsset[];
  customSkin?: string;
  availableOn?: string;
  expiresOn?: string;
  logoName?: string;
  lockType?: string;
  props?: string;
  hideExpiryTime?: boolean;
}

export interface ChestInventorySettings {
  starsRewardsExcluded?: boolean;
  hideChests: boolean;
}

export enum ChestType {
  MultiPurposeChest = 'MPC',
  StarsRewards = 'SR',
  StarsRewardsCrossVerticalLoyality = 'SRCVL2'
}

export enum AssetType {
  ChestSkin = 1,
  Podium = 2,
  Background = 3,
  Logo = 4,
  NotificationHeader = 5
}

export interface ConfigurableChestProps {
  assets: ChestAsset[];
  logoName: string;
  chestType: string;
  customSkin: string;
  tierId: number;
}

export interface ChestAsset {
  id: number;
  type: number;
  uriHint: string;
}

export interface ChestInventoryState {
  data?: {
    availableCount: number;
    chests: MpcChest[];
  };
  subscriptions: { [path: string]: string };
  settings?: ChestInventorySettings;
}
